/**
 * @generated SignedSource<<7eb15e6b1a70299ca4291ab07c6ea18b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoicePrintsSettingsQuery$variables = {};
export type VoicePrintsSettingsQuery$data = {
  readonly viewer: {
    readonly voicePrints: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"VoicePrints_voicePrint">;
    }>;
  };
};
export type VoicePrintsSettingsQuery = {
  response: VoicePrintsSettingsQuery$data;
  variables: VoicePrintsSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VoicePrintsSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VoicePrint",
            "kind": "LinkedField",
            "name": "voicePrints",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VoicePrints_voicePrint"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "VoicePrintsSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VoicePrint",
            "kind": "LinkedField",
            "name": "voicePrints",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioFileUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "sourceMeetingRecording",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceStart",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8a51679c4baf6384eb046efb0edb4bc",
    "id": null,
    "metadata": {},
    "name": "VoicePrintsSettingsQuery",
    "operationKind": "query",
    "text": "query VoicePrintsSettingsQuery {\n  viewer {\n    voicePrints {\n      id\n      ...VoicePrints_voicePrint\n    }\n    id\n  }\n}\n\nfragment VoicePrints_voicePrint on VoicePrint {\n  id\n  audioFileUrl\n  createdAt\n  sourceMeetingRecording {\n    title\n    url\n    id\n  }\n  sourceStart\n}\n"
  }
};
})();

(node as any).hash = "8cb0ae5729d8f77ec84f4baa0608dde1";

export default node;
